import React from 'react';
import {IReactView} from '@gongxigames/framework/core/fragments/react/IReactView';
import {renderReactView, unmountComponent} from '@gongxigames/framework/core/fragments/react/renderReactView';
import {Container} from 'pixi.js';

export type ReactMediatorProps = {
    view: IReactView;
};

export class ReactMediator extends React.Component<ReactMediatorProps, any, any> {
    public static fromReactView(view: IReactView): ReactMediator {
        return renderReactView(view);
    }

    public static unmountComponent(container: Container): void {
        unmountComponent(container);
    }

    constructor(props: ReactMediatorProps) {
        super(props);

        this.state = props.view.state;
    }

    public componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
        if (this.props.view.componentDidUpdate) {
            this.props.view.componentDidUpdate(prevState, snapshot);
        }
    }

    public componentWillUnmount(): void {
        if (this.view.componentWillUnmount) {
            this.view.componentWillUnmount();
        }
    }

    public componentDidMount(): void {
        if (this.view.componentDidMount) {
            this.view.componentDidMount();
        }
    }

    public render(): JSX.Element {
        this.view.state = this.state;

        return this.props.view.render();
    }

    protected get view(): IReactView {
        return this.props.view;
    }
}
